import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=a0a0bd76&scoped=true&"
import script from "./Contractors.vue?vue&type=script&lang=ts&"
export * from "./Contractors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a0bd76",
  null
  
)

export default component.exports